import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e202b92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "body" }

import { ref } from 'vue';
import { withDefaults, computed, watch } from 'vue';
import {
  ChevronDownIcon
} from '@/components/atoms';
interface Props {
  title?: string
  noChevron?: boolean
  initialShow?: boolean
  noMargin?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomAccordion',
  props: {
    title: { default: '' },
    noChevron: { type: Boolean, default: false },
    initialShow: { type: Boolean, default: false },
    noMargin: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props
const show = ref<boolean>(props.initialShow)

function toggle() {
  show.value = !show.value
}

function enter(el: any) {
  el.style.height = `${el.scrollHeight}px`
}

function leave(el: any) {
  el.style.height = ''
}

watch(
  () => props.initialShow,
  () => show.value = props.initialShow
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'my-2': !_ctx.noMargin }, `pa-4`])
  }, [
    _createElementVNode("div", {
      class: "d-flex align-center justify-space-between cursor-pointer",
      onClick: _withModifiers(toggle, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        (_ctx.$slots.iconChev)
          ? _renderSlot(_ctx.$slots, "iconChev", {
              key: 1,
              show: show.value
            })
          : _createCommentVNode("", true)
      ]),
      (!_ctx.noChevron && !_ctx.$slots.iconChev)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["d-flex ml-3 button", { 'rotate-invert': show.value }])
          }, [
            _createVNode(_unref(ChevronDownIcon))
          ], 2))
        : _renderSlot(_ctx.$slots, "titleArea", _mergeProps({
            key: 1,
            show: show.value,
            toggle: toggle
          }, _ctx.$attrs))
    ]),
    _createVNode(_Transition, {
      name: "accordion",
      onAfterEnter: leave,
      onEnter: enter,
      onAfterLeave: leave,
      onBeforeLeave: enter
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ], 512), [
          [_vShow, show.value]
        ])
      ]),
      _: 3
    })
  ], 2))
}
}

})